import Cookies from 'universal-cookie'
import { useMemo } from 'react'

export const useCookies = () => {
  return useMemo(() => new Cookies(), [])
}
